import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MovilService } from '../../services/movil.service';
import { MovilDTO } from '../../../dtos/movil.dto';
import { FormsModule } from '@angular/forms';
import moment from "moment";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AppMessage } from '../../app.message';
import { ToastrService } from 'ngx-toastr';
import { EventService } from '../../services/event.service';
import { UserService } from '../../services/user.service';

enum EstadoBus {
  DISPONIBLE = 'DISPONIBLE',
  EN_LAVADO = 'EN_LAVADO',
  EN_CARGA = 'EN_CARGA',
  // NO_DISPONIBLE = 'NO_DISPONIBLE',
  EN_TALLER = 'EN_TALLER'
}

enum Opciones {
  EXTENDER_TIEMPO = 'EXTENDER_TIEMPO',
  CAMBIAR_ESTADO = 'CAMBIAR_ESTADO'
}

const textos: Record<EstadoBus | Opciones, string> = {
  [EstadoBus.DISPONIBLE]: 'Disponible',
  [EstadoBus.EN_LAVADO]: 'En lavado',
  [EstadoBus.EN_CARGA]: 'En carga',
  // [EstadoBus.NO_DISPONIBLE]: 'No disponible',
  [EstadoBus.EN_TALLER]: 'En taller',
  [Opciones.EXTENDER_TIEMPO]: 'EXTENDER TIEMPO',
  [Opciones.CAMBIAR_ESTADO]: 'CAMBIAR ESTADO'
};

const transicionesPermitidas: Partial<Record<EstadoBus, Partial<Record<EstadoBus, string>>>> = {
  [EstadoBus.DISPONIBLE]: {
    [EstadoBus.EN_TALLER]: 'MOVIL_CAMBIAR_ESTADO_DISPONIBLE_A_TALLER',
    [EstadoBus.EN_CARGA]: 'MOVIL_CAMBIAR_ESTADO_DISPONIBLE_A_CARGA',
    [EstadoBus.EN_LAVADO]: 'MOVIL_CAMBIAR_ESTADO_DISPONIBLE_A_LAVADO',
  },
  [EstadoBus.EN_TALLER]: {
    [EstadoBus.DISPONIBLE]: 'MOVIL_CAMBIAR_ESTADO_TALLER_A_DISPONIBLE',
    [EstadoBus.EN_CARGA]: 'MOVIL_CAMBIAR_ESTADO_TALLER_A_CARGA',
  },
  [EstadoBus.EN_CARGA]: {
    [EstadoBus.DISPONIBLE]: 'MOVIL_CAMBIAR_ESTADO_CARGA_A_DISPONIBLE',
    [EstadoBus.EN_TALLER]: 'MOVIL_CAMBIAR_ESTADO_CARGA_A_TALLER',
  },
  [EstadoBus.EN_LAVADO]: {
    [EstadoBus.DISPONIBLE]: 'MOVIL_CAMBIAR_ESTADO_LAVADO_A_DISPONIBLE',
  },
};

// Respaldo por estado destino, igual que PermisoService.validarPermisoMovilEstado del backend:
// se usa cuando la transicion no tiene un permiso propio. Despachador y mantenimiento no tienen
// estos permisos, asi que solo alcanza a los perfiles sin restriccion por transicion, como admin.
const permisoPorDestino: Record<EstadoBus, string> = {
  [EstadoBus.EN_TALLER]: 'MOVIL_CAMBIAR_ESTADO_TALLER',
  [EstadoBus.DISPONIBLE]: 'MOVIL_CAMBIAR_ESTADO_DISPONIBLE',
  [EstadoBus.EN_CARGA]: 'MOVIL_CAMBIAR_ESTADO_OTROS',
  [EstadoBus.EN_LAVADO]: 'MOVIL_CAMBIAR_ESTADO_OTROS',
};

@Component({
  selector: 'app-modal-gestion-bus',
  standalone: true,
  imports: [FormsModule, TabsModule, CommonModule],
  templateUrl: './modal-gestion-bus.component.html',
  styleUrl: './modal-gestion-bus.component.scss'
})
export class ModalGestionBusComponent implements OnInit {

  public EstadoBus = EstadoBus;
  public Opciones = Opciones;
  public textos = textos;

  private movil: MovilDTO;

  public tipoDeActualizacion = Opciones.CAMBIAR_ESTADO;
  public textoBoton = textos[Opciones.CAMBIAR_ESTADO];

  public estadoSeleccionado: string = '';
  public tiempo = '';
  public enviando: boolean = false;

  constructor(
    private modalRef: BsModalRef,
    private movilService: MovilService,
    private apiService : ApiService,
    private eventService: EventService,
    private toastr: ToastrService,
    private userService: UserService
  ) {

    this.eventService.subscribe('MOVIL_ACTUALIZADO_MQTT_EVENT', (movil: MovilDTO) => {
      if(movil.uuid == this.movil.uuid) {
        this.movil = movil;
      }
    })
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  ngOnInit(): void {
    this.movil = this.movilService.getMovilSeleccionado();
    this.estadoSeleccionado = this.movil.estado;
  }

  getMovil(): MovilDTO {
    return this.movil;
  }

  getEnergiaDisponible() {
    if (!this.movil || !this.movil.tipoMovil || !this.movil.tipoMovil.combustible) {
      return '--';
    }
  
    if (this.movil.tipoMovil.combustible === 'DIESEL') {
      if (this.movil.nivelCombustible == null) {
        return '--%';
      }
      return `${this.movil.nivelCombustible}%`;
    }
  
    if (this.movil.tipoMovil.combustible === 'ELECTRICO') {
      if (this.movil.estadoCarga == null) {
        return '--%';
      }
      return `${this.movil.estadoCarga}%`;
    }
  
    return '--';
  }

  get isTiempoCritico(): string | null {

    if (!this.movil.estadoFechaTerminoPlanificado) {
      return null;
    }

    const ahora = moment();
    const fin = moment.utc(this.movil.estadoFechaTerminoPlanificado).local();

    const diff = moment.duration(fin.diff(ahora));
    if (diff.asMinutes() <= 0) {
      return 'clRed';
    } else {
      return 'clGreen';
    }
  }

  get getSucursalOrigen(){
    return this.movil.sucursalNombreActual || "--";
  }

  get getSucursalDestino(){
    return this.movil.sucursalNombreFuturo || "--";
  }

  tienePermisoExtenderTiempo(): boolean {
    return this.userService.tienePermiso('MOVIL_EXTENDER_TIEMPO');
  }

  puedeSeleccionarEstado(estadoDestino: EstadoBus): boolean {
    if (!this.movil) {
      return false;
    }
    if (estadoDestino === this.movil.estado) {
      return true;
    }
    const permiso = transicionesPermitidas[this.movil.estado as EstadoBus]?.[estadoDestino];
    if (permiso && this.userService.tienePermiso(permiso)) {
      return true;
    }
    return this.userService.tienePermiso(permisoPorDestino[estadoDestino]);
  }

  tienePermisoCambiarEstado(): boolean {
    return Object.values(EstadoBus).some(estado => estado !== this.movil.estado && this.puedeSeleccionarEstado(estado));
  }

  tienePermisoParaEnviar(): boolean {
    return this.tipoDeActualizacion === Opciones.EXTENDER_TIEMPO
      ? this.tienePermisoExtenderTiempo()
      : this.tienePermisoCambiarEstado();
  }

  onTabChanged(tab: any) {
    if (tab.heading === 'EXTENDER TIEMPO') {
      this.tipoDeActualizacion = Opciones.EXTENDER_TIEMPO;
      this.textoBoton = textos[Opciones.EXTENDER_TIEMPO]
    } else if (tab.heading = 'CAMBIAR ESTADO') {
      this.tipoDeActualizacion = Opciones.CAMBIAR_ESTADO;
      this.textoBoton = textos[Opciones.CAMBIAR_ESTADO];
    }
  }

  get getDuracionAsignado(): string {
    const inicio = moment(this.movil.estadoFechaInicio);
    const fin = moment(this.movil.estadoFechaTerminoPlanificado);
    if (!inicio.isValid() || !fin.isValid()) {
      return "--";
    }

    if (fin < inicio) {
      return "--";
    }

    const duracion = moment.duration(fin.diff(inicio));
    const horas = Math.floor(duracion.asHours());
    const minutos = duracion.minutes();
    return `${this.pad(horas)}:${this.pad(minutos)}`;
  }

  private pad(valor: number): string {
    return valor < 10 ? `0${valor}` : `${valor}`;
  }

  get getTiempoEnEstadoHHmm(): string {
    const ahora = moment();
    const inicio = moment.utc(this.movil.estadoFechaInicio).local();

    if(!inicio.isValid()){
      return "--";
    }
    const diff = moment.duration(ahora.diff(inicio));
    const horas = Math.floor(diff.asHours());
    const minutos = diff.minutes();

    return `${this.pad(Math.abs(horas))}:${this.pad(Math.abs(minutos))}`;
  }

  get getTiempoRestanteHHmm(): string {
    const ahora = moment();
    const fin = moment.utc(this.movil.estadoFechaTerminoPlanificado).local();
  
    if (!fin.isValid()) {
      return "--";
    }
  
    const diff = moment.duration(fin.diff(ahora));
    const signo = fin.isBefore(ahora) ? '-' : '';
    const horas = Math.abs(diff.hours());
    const minutos = Math.abs(diff.minutes());
  
    console.log("Diferencia - Horas:", diff.hours(), "Minutos:", diff.minutes());
  
    const tiempoFormateado = `${signo}${this.pad(horas)}:${this.pad(minutos)}`;
  
    return tiempoFormateado;
  }

  formatearTiempo(event: any) {
    const input = event.target;
    let value = input.value;
    const isBackspace = event.inputType === 'deleteContentBackward';

    // Remover todo excepto números
    value = value.replace(/[^0-9]/g, '');

    // Limitar a 4 dígitos
    if (value.length > 4) {
      value = value.slice(0, 4);
    }

    // Agregar ":" después del segundo dígito
    if (value.length >= 3) {
      value = value.slice(0, 2) + ':' + value.slice(2);
    } else if (value.length >= 2 && !isBackspace) {
      // Solo agregar ":" si no estamos borrando hacia atrás
      value = value.slice(0, 2) + ':';
    }

    input.value = value;

    // Mover cursor después del ":" si recién lo insertamos
    if (!isBackspace && value.length === 3 && value.includes(':')) {
      input.setSelectionRange(3, 3);
    }

    event.target.value = value;
    this.tiempo = value;
  }

  updateMovil() {

    if(this.tipoDeActualizacion === Opciones.CAMBIAR_ESTADO &&
      this.movil.estado === this.estadoSeleccionado
    ){
      this.toastr.warning("El estado seleccionado es igual al estado actual", 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    if(this.tipoDeActualizacion === Opciones.EXTENDER_TIEMPO &&
      this.movil.estado === 'DISPONIBLE'
    ){
      this.toastr.warning("No se puede extender tiempo a un movil en estado disponible", 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
      return;
    }

    let minutos: string | null = null;
    const requiereTiempo =
      this.tipoDeActualizacion === Opciones.EXTENDER_TIEMPO ||
      this.tiempo != '';

    if (requiereTiempo) {
      let tiempoNormalizado = this.tiempo.trim();

      let horas: number;
      let mins: number;

      if (/^\d{1,2}$/.test(tiempoNormalizado)) {
        // Solo horas
        horas = parseInt(tiempoNormalizado, 10);
        mins = 0;
      } else if (/^\d{1,3}:\d{2}$/.test(tiempoNormalizado)) {
        // HH:mm con soporte hasta 3 dígitos en horas
        const [h, m] = tiempoNormalizado.split(":").map(Number);
        horas = h;
        mins = m;
        if (mins >= 60) {
          this.toastr.warning('Los minutos no pueden ser mayores a 59', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
          return;
        }
      } else {
        this.toastr.warning('Formato inválido. Usa HH:mm, por ejemplo 02:30', 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
        return;
      }

      minutos = (horas * 60 + mins).toString();
    }

    if (this.tipoDeActualizacion === Opciones.EXTENDER_TIEMPO) {
      this.enviando = true;
      this.apiService.postExtenderTiempoGetionBuses(minutos, this.movil.numeroInterno).subscribe({
        next: (res) => this.actualizarTiempoSuccess(res),
        error: (err) => this.actualizarTiempoError(err)
      });
    }

    if (this.tipoDeActualizacion === Opciones.CAMBIAR_ESTADO) {
      this.enviando = true;
      this.apiService.postCambiarEstadoGestionBuses(this.estadoSeleccionado, minutos, this.movil.numeroInterno).subscribe({
        next: (res) => this.actualizarEstadoSuccess(res),
        error: (err) => this.actualizarEstadoError(err)
      });
    }
  }

  actualizarTiempoSuccess(resp: any) {
    this.eventService.publish('EXTENDER_TIEMPO_MOVILES_EVENT');
    this.enviando = false;
    this.close();
  }

  actualizarTiempoError(error: HttpErrorResponse){
    console.log('error lista viajes', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_POST_EXTENDER_TIEMPO_MOVILES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  actualizarEstadoSuccess(resp : any){
    this.eventService.publish('CAMBIAR_ESTADO_MOVILES_EVENT');
    this.enviando = false;
    this.close();
  }

  actualizarEstadoError(error) {
    console.log('error lista viajes', error);
    this.enviando = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_POST_CAMBIAR_ESTADO_MOVILES_WS;
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  close() {
    this.modalRef.hide();
  }

}
